<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>
    <div class="flex justify-between mb-6 hide">
      <search-filter v-model="form.search" v-show="false" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      
    </div>
    <div v-if="(auth.user.role =='ADMIN')" class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Sitename</th>
            <th class="pb-4 pt-6 px-6">City</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Phone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="jobsite in jobsites.data" :key="jobsite.id" class="hover:bg-gray-100 focus-within:bg-gray-100" v-show="jobsite.id > 0">
            
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/jobsites/${jobsite.id}/edit`">
                {{ jobsite.sitename }}
                <icon v-if="jobsite.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/jobsites/${jobsite.id}/edit`" tabindex="-1">
                {{ jobsite.city }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/jobsites/${jobsite.id}/edit`" tabindex="-1">
                {{ jobsite.phone }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/jobsites/${jobsite.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="jobsites.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No jobsites found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="jobsites.links" />
  </div>
  <br/>
  <div>
    <Link v-if="auth.user.role =='ADMIN'" class="btn-indigo float-right" href="/jobsites/create">
      <span>Create Jobsite</span>
    </Link>
  </div>
  <div id="updatejobsite"></div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    jobsites: Object,
    role: String,
    auth: Object,
  },
  mounted() {
      window.setTimeout(function() {
        if (document.querySelector('#jobsiteselector').value == '' && document.querySelectorAll('#jobsiteselector option').length == 2) {
          document.querySelector('#jobsiteselector').selectedIndex = 1;
          var eventchange = new Event('eventchange');
          document.querySelector('#jobsiteselector').dispatchEvent(eventchange);

          document.cookie = 'jobsite=' + document.querySelectorAll('#jobsiteselector option')[1].value +';path=/;';
          try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
          } catch(e) { console.error(e); }
         }
      },250);
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/jobsites', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
